import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "To achieve both the desired artistic goal and consistent playback, the rendering process is controlled by metadata parameters. One aspect controlled in this way is the perceptual size of the object. Use headphones to listen and compare how different size settings affect the impression of a spatially stretched sound source (click on the picture to start playback).",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      gap: "3% 5%",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/03/23/principle/principle-2-0_00.png`,
                  audioUrl: `${config.ASSETS_URL}/03/23/principle/principle-2-0_00.wav`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/03/23/principle/principle-2-0_33.png`,
                  audioUrl: `${config.ASSETS_URL}/03/23/principle/principle-2-0_33.wav`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/03/23/principle/principle-2-0_66.png`,
                  audioUrl: `${config.ASSETS_URL}/03/23/principle/principle-2-0_66.wav`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioImage",
                options: {
                  imageSrc: `${config.ASSETS_URL}/03/23/principle/principle-2-1_00.png`,
                  audioUrl: `${config.ASSETS_URL}/03/23/principle/principle-2-1_00.wav`,
                },
              },
            },
          },
        ],
      ],
    },
    styles: {
      padding: "4% 2%",
    },
  },
};

export default principle;
